/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import AuthService from "./AuthService";

class FinanceiroService {
    constructor() {
        this.apiUrl = process.env.REACT_APP_API_URL || "https://portalrelacionamentoapi.dev-gam.com";
    }

    async getDevolucoes(cdCliente, filtros) {
        try {
            if (!AuthService.getToken()) {
                await AuthService.login();
            }

            const response = await axios.post(
                `${this.apiUrl}/devolucao/listar/${cdCliente}`,
                filtros, // Envia o objeto `filtros` no corpo da requisi��o
                {
                    headers: {
                        Authorization: `Bearer ${AuthService.getActiveToken()}`,
                    },
                }
            );
            const conteudo = response.data.conteudo;

            return conteudo;
        } catch (error) {
            console.error("Erro ao buscar dados de devolu��o:", error);
            throw new Error("Erro ao buscar de devolu��o.");
        }
    }
}

export default new FinanceiroService();
